import {getRetailDevicesPending, getRetailDevicesSuccess, getRetailDevicesError} from './index';
import config from '../../oktaConfig';

function getRetailDevices(accessToken, siteId) {
  return dispatch => {
    dispatch(getRetailDevicesPending());

    fetch(`${config.resourceServer.insightsApiUrlRetailDevices}?siteId=${siteId}`, {
      mode: 'cors',
      credentials: 'include',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then(response => {
        if (!response.ok) {
          return Promise.reject();
        }
        return response.json();
      })
      .then(data => {
        dispatch(getRetailDevicesSuccess(data));
      })
      .catch(err => {
        dispatch(getRetailDevicesError(err));
        /* eslint-disable no-console */
        console.error('Unable to retrieve retail devices', err);
      });
  };
}

export default getRetailDevices;
